import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { ArrowRightSVG } from '@common_components/svg/arrowRight.svg';

export const SortIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <ArrowRightSVG/>
    </div>
  );
};
